<template>
	<div class="objectScndNest">
		<!-- <pre>
			{{ $route.params}}
			{{ ApiData }}
		</pre> -->
		<div>
			<ReClientNeeds />
			<ReSearchScndFlatBig :objData="ApiData[0]" />

			<!--ниже до следующего большого US-->
			<!-- <div>
				<div class="row justify-content-between mx-0">
					<h3>Данный объект на других площадках и от других лиц</h3>
					<el-select						
						class="col-md col-xl-6 px-0 select-primary  overflow-overlay"						
						filterable
						placeholder="Выберите источник"
						multiple						
						size="large"
						
					>
						<el-option
							class="select-primary long-select"
							v-for="option in masAdSource.options"
							:key="option.label"
							:label="option.label"
							:value="option.value"
						>
						</el-option>
					</el-select>
				</div>
			</div> -->
			<!-- <ReSearchScndObjSmall :objData="ApiData[0]" /> -->
		</div>
	</div>
</template>
<script>
import ReSearchScndFlatBig from 'src/our_components/ReSearchScndFlatBig.vue'; 
// import ssoModuleFilter from 'src/our_modules/SearchSendObjects/sso_module_filter.vue';
import ReClientNeeds from 'src/our_modules/SearchSendObjects/ReClientNeeds.vue';
import { Select, Option, } from 'element-ui';
// import ReSearchScndObjSmall from 'src/our_modules/SearchSendObjects/ReSearchScndObjSmall.vue'; 

export default {
	name: 'objectscndnest-page',
	components: {
		// ssoModuleFilter,
		ReClientNeeds,
		ReSearchScndFlatBig,
		[Option.name]: Option,
		[Select.name]: Select,
		// ReSearchScndObjSmall,
	},
	data() {
		return {
			ApiData: {},
			// CellData: {},
			objGetParams: {},
			bIsLoading: false,
			masAdSource: {
				options: [
					{value: '0',label: '1 - avito.ru',},
					{value: '1',label: '2 - irr.ru',},
					{value: '2',label: '3 - realty.yandex.ru',},
					{value: '3',label: '4 - cian.ru',},
					{value: '4',label: '5 - sob.ru',},
					{value: '5',label: '6 - youla.io',},
					{value: '6',label: '10 - moyareklama.ru',},
				],
			},
		};
	},
	watch: {
		// '$route' (to, from) {
		// 	if(this.$route.params.object_type == 'complex'){
		// 		if(typeof this.ApiData[0] != 'undefined'){
		// 			this.getApiFlatsData();
		// 		}
		// 	}
		// }
	},
	methods: {
		getApiData(){
			this.bIsLoading = true;
			const objGetParams = this.$GVO.GetAllGet();
			this.$GVO.ApiCall('GET',{obj:'SecondObj',flt:Object.assign(
				{
					id: this.$route.params.object_id
				},
				(typeof objGetParams.task_id != 'undefined' && typeof objGetParams.taskend_id != 'undefined' && typeof objGetParams.client_id != 'undefined')?	{
					client_id:objGetParams.client_id,
					task_id:objGetParams.task_id,
					taskend_id:objGetParams.taskend_id
				}:{}
			)})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		

	},
	mounted() {
		this.getApiData();
	}
};
</script>
<style scoped>

.oneline {
	border: 1px solid #9e77f3;
	padding: 10px 15px;
	border-radius: 0.2857rem;
	box-shadow: 0 1px 15px 0 rgba(158, 119, 243, 0.08);
	flex-direction: column;
}
@media (max-width: 768px) {
	.oneline {
		flex-wrap: wrap;
	}
}

</style>
